// extracted by mini-css-extract-plugin
module.exports = {"center":"page-title-banner_center__ZnIdb","container":"page-title-banner_container__8ISxz","content-container":"page-title-banner_content-container__XNJzv"};